import React from 'react';

export default function GoldChainSvg({ size = 40, className = '' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" className={className}>
      {/* Chain links - draped necklace */}
      <circle cx="8" cy="16" r="2" stroke="#D4A830" strokeWidth="1.5" fill="none" />
      <circle cx="12" cy="18" r="2" stroke="#D4A830" strokeWidth="1.5" fill="none" />
      <circle cx="16" cy="20" r="2" stroke="#D4A830" strokeWidth="1.5" fill="none" />
      <circle cx="20" cy="22" r="2" stroke="#D4A830" strokeWidth="1.5" fill="none" />
      <circle cx="24" cy="20" r="2" stroke="#D4A830" strokeWidth="1.5" fill="none" />
      <circle cx="28" cy="18" r="2" stroke="#D4A830" strokeWidth="1.5" fill="none" />
      <circle cx="32" cy="16" r="2" stroke="#D4A830" strokeWidth="1.5" fill="none" />
      {/* Inner gold fill for links */}
      <circle cx="8" cy="16" r="1" fill="#E8C040" />
      <circle cx="12" cy="18" r="1" fill="#E8C040" />
      <circle cx="16" cy="20" r="1" fill="#E8C040" />
      <circle cx="24" cy="20" r="1" fill="#E8C040" />
      <circle cx="28" cy="18" r="1" fill="#E8C040" />
      <circle cx="32" cy="16" r="1" fill="#E8C040" />
      {/* Pendant */}
      <circle cx="20" cy="28" r="4" fill="#D4A830" />
      <circle cx="20" cy="28" r="3" fill="#E8C040" />
      {/* Pendant gem */}
      <circle cx="20" cy="28" r="1.5" fill="#FF4444" />
      <circle cx="19.5" cy="27.5" r="0.5" fill="#FF8888" />
      {/* Pendant ring */}
      <circle cx="20" cy="24" r="1" stroke="#D4A830" strokeWidth="0.8" fill="none" />
      {/* Highlight */}
      <path d="M18 26L19 25" stroke="#FFE880" strokeWidth="0.5" opacity="0.6" />
    </svg>
  );
}
